import TextBlock from "./TextBlock";
import styles from "./DiagonalDivider.module.css";
import UnserWerkstoffIcon from "../assets/Icons/Icons_Unser_Werkstoff.svg";
import IhrWerkstoffIcon from "../assets/Icons/Icons_Ihr Wertstoff.svg";
import ZukunftWerkstoffIcon from "../assets/Icons/Icons_Material_Zukunft.svg";
import { DiagonalLabel } from "./DiagonalLabel";

const textBlocks = [
  {
    title: <>Stahl ist unser<br />Werkstoff.</>,
    paragraphs: [
      "Aus dem Hochleistungsmaterial produzieren wir Ihre Produkte. Speziell entwickelt nach Ihren Wünschen und für Ihre Anforderungen. Als Einzelstück, Klein- oder Großserie. Klassisch oder als Sonderkonstruktion.",
    ],
    Icon: UnserWerkstoffIcon,
  },
  {
    title: <>Stahl ist Ihr<br />Wertstoff.</>,
    paragraphs: [
      "Konstruktion, mechanische Belastung, Umweltbedingungen: Ihre Projektanforderungen entscheiden darüber, welcher Stahl zum Einsatz kommt. Wir entwickeln für Sie intelligente Konstruktionen mit maßvollem Materialverbrauch. Das Ergebnis ist so robust wie ressourcenschonend – und optimiert Ihre Prozesse.",
    ],
    Icon: IhrWerkstoffIcon,
  },
  {
    title: <>Stahl ist<br />das Material<br />für die Zukunft.</>,
    paragraphs: [
      "Wir nutzen ausschließlich projektbezogenen und hochwertigen Stahl. Unsere Produkte sind deshalb extrem belastbar und langlebig. Das macht sie rentabel und ressourcenschonend. Ein zusätzliches Nachhaltigkeitsplus: Stahl ist nahezu unbegrenzt und ohne Qualitätsverlust wiederverwertbar.",
    ],
    Icon: ZukunftWerkstoffIcon,
  },
];

export default function DiagonalDivider() {
  return (
    <div className={styles.diagonalDivider}>
      <div className={styles.diagonalDividerBg} />

      <div className={styles.textBlocksContainer}>
        {textBlocks.map((block, index) => (
          <TextBlock
            key={index}
            title={block.title}
            paragraphs={block.paragraphs}
            Icon={block.Icon}
          />
        ))}
      </div>

      <div className={styles.greenTagline}>
        <div className={styles.greenTaglineContent}>
          <p>
            Unsere Produkte aus Stahl, ob Standard oder maßgeschneidert machen Ihre Prozesse – in Logistik oder Produktion – spürbar besser. Wir nennen das den Stahlfaktor. Nutzen Sie ihn.
          </p>
          <div className={styles.label}>
            <DiagonalLabel />
          </div>
        </div>
      </div>
    </div>
  );
}
